import React from "react";
import { BrowserRouter as Router, Link, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage/HomePage";
import EarlyAccess from "./pages/EarlyAccess/EarlyAccess";
import Success from "./pages/EarlyAccess/Success";
import { ParallaxProvider } from "react-scroll-parallax";
import styled from "styled-components";

const Container = styled.div`
  /* overflow-x: 'hidden'; */
`;

function App() {
  return (
    <ParallaxProvider>
      <Container>
        <Router>
          <Routes>
            <Route path="/early-access" element={<EarlyAccess />} />
            <Route path="/success" element={<Success />} />
            <Route path="/" element={<HomePage />} />
          </Routes>
        </Router>
      </Container>
    </ParallaxProvider>
  );
}

export default App;
